// test2000
(2000 && 0);
